import { SET_EXCHANGE_RATE, LOADING_EXCHANGE_RATE, EXCHANGE_RATE_ERROR } from '../actions/types'

const initialState = {
  exchangeRate: null,
  loading: false,
  error: null,
}

export default function currencyReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING_EXCHANGE_RATE:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SET_EXCHANGE_RATE:
      return {
        ...state,
        exchangeRate: action.payload,
        loading: false,
        error: null,
      }
    case EXCHANGE_RATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
